module.exports = __webpack_public_path__ + "img/pr-7.d266a10d.png";